if (!customElements.get('pdp-addon-widget')) {
  customElements.define(
    'pdp-addon-widget',
    class PdpAddonWidget extends HTMLElement {
      constructor() {
        super();
      }
    
      connectedCallback() {   
        const setHeightVariables = () => {
          const productForm = this.querySelector('[data-product-form]');
          if (!productForm.scrollHeight) return;
          
          productForm.style = `--height: ${productForm.scrollHeight}px`;
        }
        
        this.addEventListener('click', (e) => {
          const clickedEl = e.target.closest('[data-action]');
          if (!clickedEl || clickedEl?.getAttribute('disabled')) return;
          
          setHeightVariables();
          
          const {
            action
          } = clickedEl.dataset;
          
          switch(action) {
            case 'close-addon':
              this.classList.remove('active')
            break;
            case 'open-addon':
              const productForm = this.querySelector('[data-product-form]');

              this.classList.add('active');

            break;
            default: break;
          }

        });
      }
    }
  );
}